var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultaBlackVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7FEFA19-920E-4E29-9148-E486FD3A5EA1@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "08---Consultas-Online",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-M-08-01-19-Detalhe-consulta-marcada-com-pagamento-pendente",
    transform: "translate(-74.000000, -666.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marcacao",
    transform: "translate(0.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(54.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ELEMENTS-/-ICONS-/-Consulta-Online-/-Scheduled",
    transform: "translate(0.937500, 3.437500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7944219,0.891969524 L13.1651953,3.36467161 L13.1651953,2.56681877 C13.1651953,1.14920391 12.195612,0 10.9995703,0 L2.165625,0 C0.969583339,0 0,1.14920391 0,2.56681877 L0,10.5581812 C0,11.9757961 0.969583339,13.125 2.165625,13.125 L10.9995703,13.125 C12.195612,13.125 13.1651953,11.9757961 13.1651953,10.5581812 L13.1651953,9.76032839 L16.7944219,12.2330305 C17.4820078,12.7014749 18.046875,12.3164521 18.046875,11.3774242 L18.046875,1.75185381 C18.046875,0.808547914 17.4838125,0.423525098 16.7944219,0.891969524 Z",
    id: "lists/icon_camera-small"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultaBlackVideoIcon);
export default __webpack_public_path__ + "static/media/consulta-black-video-icon.2926a6ed800198edce0a23dd48095a12.svg";
export { ForwardRef as ReactComponent };